// extracted by mini-css-extract-plugin
module.exports = {"loader":"SmallLoader_loader__rOmiI","rotation":"SmallLoader_rotation__ttYP0","hide":"SmallLoader_hide__plEzi"};